if (!customElements.get("m-scrolling-promotion")) {
  class MScrollingPromotion extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.promotion = this.querySelector(".m-promotion");
      this.init();

      if (window.Shopify && window.Shopify.designMode) {
        document.addEventListener("shopify:block:select", (e) => {
          if (this.contains(e.target)) {
            this.scrollingPause();
          }
        });
        document.addEventListener("shopify:block:deselect", (e) => {
          if (this.contains(e.target)) {
            this.scrollingPlay();
          }
        });
      }
    }

    init() {
      if (!this.promotion) return;

      this.promotion.classList.add("m-promotion--animated");

      for (let index = 0; index < 10; index++) {
        const clone = this.promotion.cloneNode(true);
        clone.setAttribute("aria-hidden", "true");

        this.appendChild(clone);
      }

      // pause when out of view
      if (!this.observer) {
        this.observer = new IntersectionObserver(
          (entries, _observer) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                this.scrollingPlay();
              } else {
                this.scrollingPause();
              }
            });
          },
          { rootMargin: "0px 0px 50px 0px" }
        );
        this.observer.observe(this);
      }
    }

    scrollingPlay() {
      this.classList.remove("m-scrolling-promotion--paused");
    }

    scrollingPause() {
      this.classList.add("m-scrolling-promotion--paused");
    }
  }

  customElements.define("m-scrolling-promotion", MScrollingPromotion);

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener("shopify:section:load", (e) => {
      const promotionEl = e.target.querySelector("m-scrolling-promotion");
      if (promotionEl && typeof promotionEl.init === "function") {
        promotionEl.init();
      }
    });
  }
}
